/* TOZ24: Mini-Bilder-Leiste der Live-Product-Options-Galerie wie bei ESN
   (Styling: assets/toz-lpo-gallery.css)
   - max. 5 Mini-Bilder sichtbar, 24px Abstand zwischen den Mini-Bildern
   - Pfeil oben/unten = vorheriges/nächstes Bild, Hauptbild wechselt mit,
     die Leiste scrollt dabei um ein Bild
   - Pfeil nur, wenn in die Richtung noch Bilder folgen; Blende nur unten */
(function () {
  var MAX_VISIBLE = 5;
  var ARROW_SPACE = 40;
  var THUMB_GAP = 24; /* Abstand zwischen den Mini-Bildern wie bei ESN */
  var instances = window.__tozSplides || (window.__tozSplides = []);

  var SVG_UP = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11.29 6.79a1 1 0 0 1 1.42 0l7.5 7.5a1 1 0 0 1-1.42 1.42L12 8.91l-6.79 6.8a1 1 0 0 1-1.42-1.42l7.5-7.5Z"/></svg>';
  var SVG_DOWN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.79 8.29a1 1 0 0 1 1.42 0L12 15.09l6.79-6.8a1 1 0 1 1 1.42 1.42l-7.5 7.5a1 1 0 0 1-1.42 0l-7.5-7.5a1 1 0 0 1 0-1.42Z"/></svg>';

  /* Splide-Instanzen der App abgreifen (die App gibt sie nicht nach außen) */
  function hookSplide() {
    var S = window.Splide;
    if (!S || !S.prototype) return false;
    var P = S.prototype;
    if (P.__tozHooked) return true;
    ['mount', 'is', 'go', 'emit', 'on', 'refresh'].forEach(function (name) {
      var orig = P[name];
      if (typeof orig !== 'function') return;
      P[name] = function () {
        if (instances.indexOf(this) < 0) instances.push(this);
        return orig.apply(this, arguments);
      };
    });
    P.__tozHooked = true;
    return true;
  }

  function findSplide(root) {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (instances[i] && instances[i].root === root) return instances[i];
    }
    return null;
  }

  function metrics(root) {
    var track = root.querySelector('.splide__track');
    var list = root.querySelector('.splide__list');
    var slides = list ? list.children : [];
    if (!track || !slides.length || !slides[0].offsetHeight) return null;
    var h = slides[0].offsetHeight;
    var gap = slides.length > 1 ? Math.max(0, slides[1].offsetTop - slides[0].offsetTop - h) : 0;
    var last = slides[slides.length - 1];
    return {
      track: track, list: list, count: slides.length,
      step: h + gap, gap: gap,
      content: last.offsetTop + last.offsetHeight,
      view: track.clientHeight
    };
  }

  function getY(root, nav) {
    if (nav && nav.Components && nav.Components.Move) return nav.Components.Move.getPosition();
    var list = root.querySelector('.splide__list');
    var m = list && (list.style.transform || '').match(/translateY\((-?[\d.]+)px\)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function update(root) {
    var m = metrics(root);
    if (!m) return;
    var y = getY(root, findSplide(root));
    root.classList.toggle('toz-tn-overflow', m.content > m.view + 1);
    root.classList.toggle('toz-tn-above', y < -1);
    root.classList.toggle('toz-tn-below', m.content + y > m.view + 1);
  }

  /* Höhe der Leiste auf ganze Mini-Bilder (max. 5) setzen, wie bei ESN */
  function layout(root) {
    var nav = findSplide(root);
    if (!nav) return;
    if (nav.options.gap !== THUMB_GAP) {
      nav.options = { gap: THUMB_GAP };
      nav.refresh();
    }
    var m = metrics(root);
    if (!m) return;
    var gallery = root.closest('.cl-po--gallery');
    var mainTrack = gallery && gallery.querySelector('.cl-po--gallery-main .splide__track');
    var mainH = mainTrack ? mainTrack.getBoundingClientRect().height : 600;
    var fit = Math.floor((mainH - 2 * ARROW_SPACE + m.gap) / m.step);
    var visible = Math.max(3, Math.min(MAX_VISIBLE, fit));
    if (m.count <= visible) visible = m.count;
    var height = visible * m.step - m.gap;
    if (Math.abs((parseFloat(nav.options.height) || 0) - height) > 1) {
      nav.options = { height: height };
      nav.refresh();
    }
    update(root);
  }

  /* Pfeil = nächstes/vorheriges Bild: Hauptbild wechselt, Leiste scrollt mit */
  function stepOne(root, dir) {
    var nav = findSplide(root);
    if (nav) {
      nav.go(dir > 0 ? '>' : '<');
      return;
    }
    var gallery = root.closest('.cl-po--gallery') || document;
    var arrow = gallery.querySelector('.cl-po--gallery-main .splide__arrow--' + (dir > 0 ? 'next' : 'prev'));
    if (arrow) arrow.click();
  }

  function makeArrow(root, dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'toz-tn-arrow toz-tn-arrow--' + (dir < 0 ? 'up' : 'down');
    b.setAttribute('aria-label', dir < 0 ? 'Vorheriges Bild' : 'Nächstes Bild');
    b.innerHTML = dir < 0 ? SVG_UP : SVG_DOWN;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      stepOne(root, dir);
    });
    return b;
  }

  function init(root, tries) {
    if (root.dataset.tozTn === 'ready') return;
    if (root.dataset.tozTn === 'pending' && !tries) return;
    var list = root.querySelector('.splide__list');
    if (!list) return;
    if (!findSplide(root)) {
      /* Instanz noch nicht gefunden: Resize auslösen, damit Splide sich meldet */
      root.dataset.tozTn = 'pending';
      if ((tries || 0) < 10) {
        window.dispatchEvent(new Event('resize'));
        setTimeout(function () { init(root, (tries || 0) + 1); }, 300);
      }
      return;
    }
    root.dataset.tozTn = 'ready';
    root.appendChild(makeArrow(root, -1));
    root.appendChild(makeArrow(root, 1));
    new MutationObserver(function () { update(root); })
      .observe(list, { attributes: true, attributeFilter: ['style'] });
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { layout(root); }, 150);
    });
    layout(root);
    setTimeout(function () { layout(root); }, 600);
  }

  function scan() {
    if (!hookSplide()) return;
    var roots = document.querySelectorAll('.cl-po--gallery-thumbnails.is-initialized');
    for (var i = 0; i < roots.length; i++) init(roots[i], 0);
  }

  hookSplide();
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

/* TOZ24: Kopfzeile im Gravurfeld ("Personalisieren" links, Preis + statisches
   Aktions-Badge rechts). Der Preis (Streichpreis = Gravur-Produkt, Endpreis =
   abzüglich festem Betrag aus Theme-Setting engraving_discount_amount bzw. bei
   Full-Custom je Seite engraving_discount_front_amount / engraving_discount_back_amount)
   kommt aus den data-engraving-price-*-Attributen der <product-form> (product-add-to-cart.liquid);
   Full-Custom liefert zusätzlich data-engraving-front-/back-price-*: die Kopfzeile
   zeigt dann nur die Vorderseite, der Rückseiten-Preis steht an der Checkbox
   "Rückseite personalisieren" (ensureBackPrice).
   Ohne diese Attribute greifen die festen Fallback-Werte unten. Die App rendert
   das Feld selbst und kann es neu aufbauen, daher per MutationObserver immer
   wieder sicherstellen. Styling: toz-lpo-gallery.css */
(function () {
  /* Text des Badges rechts in der Kopfzeile (CSS setzt ihn in Grossbuchstaben) */
  var BADGE_TEXT = 'Weihnachtsspecial';

  /* Fallback-Preise, falls die <product-form> keine data-engraving-price-*-Attribute hat
     (z. B. Gravur-Produkt nicht über all_products auflösbar) */
  var FALLBACK_OLD = '€4,90';
  var FALLBACK_OLD_MULTI = '€9,90';
  var FALLBACK_NEW = '€0,00';

  var BADGE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="12" height="12" fill="none" aria-hidden="true" focusable="false"><path d="M1.5 6.5h13V9h-13zM3 9h10v5.5H3zM7 6.5h2V14.5H7zM8 6.5C6 6.5 4.5 5.5 4.5 4.25S5.5 2 6.5 2 8 4 8 6.5zm0 0C10 6.5 11.5 5.5 11.5 4.25S10.5 2 9.5 2 8 4 8 6.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';

  var HEAD_HTML =
    '<span class="toz-perso-head__label">Personalisieren</span>' +
    '<span class="toz-perso-head__price">' +
      '<s class="toz-perso-head__old">' + FALLBACK_OLD + '</s>' +
      '<span class="toz-perso-head__new">' + FALLBACK_NEW + '</span>' +
    '</span>' +
    '<span class="toz-perso-head__code" title="' + BADGE_TEXT + '">' +
      BADGE_ICON +
      '<span class="toz-perso-head__code-text">' + BADGE_TEXT + '</span>' +
    '</span>';

  var PREVIEW_BTN_HTML =
    '<span>Vorschau ansehen</span>' +
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11.29 6.79a1 1 0 0 1 1.42 0l7.5 7.5a1 1 0 0 1-1.42 1.42L12 8.91l-6.79 6.8a1 1 0 0 1-1.42-1.42l7.5-7.5Z"/></svg>';

  /* Vorschau-Zustand: Front (Bild 1 / Text 1) und Rückseite (Bild 2 / Text 2).
     - "Vorschau ansehen"-Button (nur mobil) im Text-Schritt bzw. im letzten
       Rückseiten-Schritt, sobald dort Bild oder Text vorhanden ist
     - Badge auf Galeriebild 1 ("Vorschau Vorderseite") bzw. 2 ("Vorschau Rückseite");
       beim einfachen Textfeld wie bisher nur "Vorschau" auf Bild 1 */
  function isBack(opt) {
    return /\s\d+$/.test(opt.getAttribute('data-option') || '');
  }

  function optFilled(opt) {
    var field = opt.querySelector('textarea.cl-po--input, input[type="text"].cl-po--input');
    if (field && field.value.trim()) return true;
    var up = opt.querySelector('.cl-po--upload');
    var hidden = up && up.querySelector('input[type="hidden"][name^="properties"]');
    return !!(hidden && hidden.value);
  }

  function backHost(container) {
    var backs = [].filter.call(container.querySelectorAll(':scope > .cl-po--option'), isBack);
    for (var i = backs.length - 1; i >= 0; i--) {
      if (backs[i].querySelector('textarea, input[type="text"]')) return backs[i];
    }
    return backs.length ? backs[backs.length - 1] : null;
  }

  function makePreviewBtn(opt, slide) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'toz-perso-preview-btn';
    btn.setAttribute('data-slide', String(slide));
    btn.innerHTML = PREVIEW_BTN_HTML;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToPreview(opt, slide);
    });
    opt.appendChild(btn);
    return btn;
  }

  function ensureBadge(index, text, on) {
    var slide = document.querySelectorAll('.cl-po--gallery-main .splide__list > .splide__slide')[index];
    if (!slide) return;
    var badge = slide.querySelector('.toz-preview-badge');
    if (!badge) {
      if (!on) return;
      badge = document.createElement('span');
      badge.className = 'toz-preview-badge';
      badge.setAttribute('aria-hidden', 'true');
      (slide.querySelector('.cl-po--preview-wrapper') || slide).appendChild(badge);
    }
    if (badge.textContent !== text) badge.textContent = text;
    badge.classList.toggle('is-on', !!on);
  }

  function syncPreview() {
    var frontAll = false, backAll = false, multiAny = false;
    var containers = document.querySelectorAll('.cl-po--options');
    for (var c = 0; c < containers.length; c++) {
      var container = containers[c];
      var opts = container.querySelectorAll(':scope > .cl-po--option');
      var multi = container.classList.contains('toz-perso-multi');
      var front = false, back = false;
      for (var i = 0; i < opts.length; i++) {
        if (!optFilled(opts[i])) continue;
        if (isBack(opts[i])) back = true; else front = true;
      }
      var textOpt = container.querySelector(':scope > .cl-po--option[data-option="Text"]');
      if (textOpt) textOpt.classList.toggle('toz-has-text', front);
      /* Rückseiten-Button nur in der grossen Box, genau einmal im letzten Rückseiten-Schritt */
      var host = multi ? backHost(container) : null;
      var stray = container.querySelectorAll('.toz-perso-preview-btn[data-slide="1"]');
      for (var k = 0; k < stray.length; k++) {
        if (stray[k].parentElement !== host) stray[k].remove();
      }
      if (host) {
        if (!host.querySelector(':scope > .toz-perso-preview-btn[data-slide="1"]')) makePreviewBtn(host, 1);
        host.classList.toggle('toz-has-text', back);
      }
      frontAll = frontAll || front;
      backAll = backAll || back;
      multiAny = multiAny || multi;
    }
    document.body.classList.toggle('toz-perso-has-text', frontAll);
    ensureBadge(0, multiAny ? 'Vorschau Vorderseite' : 'Vorschau', frontAll);
    ensureBadge(1, 'Vorschau Rückseite', multiAny && backAll);
  }

  /* Cloudlift validation can render a banner at the bottom of the option.
     Hide only the floating preview button while a visible validation message exists;
     its bottom-right coordinates are otherwise completely unchanged. */
  function syncValidation(opt) {
    var selectors = '.cl-po--error, .cl-po--error-message, .cl-po--validation-error, [role="alert"], [aria-live="assertive"]';
    var warnings = opt.querySelectorAll(selectors);
    var visible = false;
    for (var j = 0; j < warnings.length; j++) {
      var el = warnings[j];
      if (el.textContent.trim() && el.getClientRects().length &&
          getComputedStyle(el).visibility !== 'hidden') {
        visible = true;
        break;
      }
    }
    /* Fallback for Cloudlift's custom engraving/emoji warning banner. */
    if (!visible) {
      var nodes = opt.querySelectorAll('div, span, p');
      for (var k = 0; k < nodes.length; k++) {
        var n = nodes[k];
        if (n.children.length || !n.getClientRects().length) continue;
        if (/emojis sind gravurbedingt|emojis.*gravur|zeichen.*nicht.*erlaubt/i.test(n.textContent.trim())) {
          visible = true;
          break;
        }
      }
    }
    opt.classList.toggle('toz-perso-validation-visible', visible);
  }

  /* Hauptgalerie auf Bild "index" stellen (falls nicht schon aktiv) */
  function goToSlide(index) {
    var list = window.__tozSplides || [];
    for (var i = list.length - 1; i >= 0; i--) {
      var inst = list[i];
      if (inst && inst.root && inst.root.classList.contains('cl-po--gallery-main') &&
          document.documentElement.contains(inst.root)) {
        if (inst.index !== index) inst.go(index);
        return;
      }
    }
    var thumbs = document.querySelectorAll('.cl-po--gallery-thumbnails .splide__list > .splide__slide');
    if (thumbs[index]) thumbs[index].click();
  }

  /* Mobil: hoch zur Galerie, Tastatur schließen, Header-Höhe berücksichtigen,
     und das passende Bild zeigen (0 = Front, 1 = Rückseite) */
  function scrollToPreview(opt, slide) {
    var active = document.activeElement;
    if (active && opt.contains(active) && active.blur) active.blur();
    goToSlide(slide || 0);
    var target = document.querySelector('.thb-product-detail .cl-po--gallery') ||
                 document.querySelector('.thb-product-detail .product-gallery-sticky');
    if (!target) return;
    var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var y = target.getBoundingClientRect().top + window.scrollY - headerH - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function makeHead() {
    var head = document.createElement('div');
    head.className = 'toz-perso-head';
    head.setAttribute('aria-hidden', 'true');
    head.innerHTML = HEAD_HTML;
    return head;
  }

  /* Preise aus der <product-form> der Produktseite: erst in derselben Produkt-
     Section wie das Gravurfeld suchen, sonst die erste auf der Seite.
     side = 'front' | 'back' liest die Je-Seite-Attribute des Full-Custom-Shakers
     (data-engraving-front-/back-price-*), ohne side die Summe (Standardfall).
     Rückgabe null = keine dynamischen Daten (Fallback-Texte bleiben). */
  function findPrices(opt, side) {
    var attr = 'data-engraving-' + (side ? side + '-' : '') + 'price';
    var sel = 'product-form[' + attr + '-formatted]';
    var section = opt.closest('.thb-product-detail, .shopify-section');
    var form = (section && section.querySelector(sel)) || document.querySelector(sel);
    if (!form) return null;
    var oldText = form.getAttribute(attr + '-formatted');
    var newText = form.getAttribute(attr + '-final-formatted') || oldText;
    if (!oldText) return null;
    return { oldText: oldText, newText: newText };
  }

  /* Streichpreis + Endpreis in ein Elementpaar schreiben; textContent nur bei
     Abweichung setzen, damit der MutationObserver keine Endlosschleife auslöst.
     Ohne Rabatt (Endpreis = Originalpreis) keinen Streichpreis anzeigen. */
  function setPriceTexts(oldEl, newEl, oldText, newText) {
    var hideOld = oldText === newText;
    if (oldEl.textContent !== oldText) oldEl.textContent = oldText;
    if (newEl.textContent !== newText) newEl.textContent = newText;
    if (oldEl.hidden !== hideOld) oldEl.hidden = hideOld;
  }

  /* Kopfzeile mit den Preisen befüllen. In der grossen Box (multi) nur die
     Vorderseite, falls Liquid sie einzeln liefert; sonst wie bisher die Summe. */
  function syncHeadPrices(head, opt, multi) {
    if (!head) return;
    var oldEl = head.querySelector('.toz-perso-head__old');
    var newEl = head.querySelector('.toz-perso-head__new');
    if (!oldEl || !newEl) return;
    var prices = (multi && findPrices(opt, 'front')) || findPrices(opt);
    var oldText = prices ? prices.oldText : (multi ? FALLBACK_OLD_MULTI : FALLBACK_OLD);
    var newText = prices ? prices.newText : FALLBACK_NEW;
    setPriceTexts(oldEl, newEl, oldText, newText);
  }

  /* Rückseiten-Preis rechts in der Checkbox-Zeile "Rückseite personalisieren"
     (ohne Aktions-Badge). Ohne data-engraving-back-price-* wird nichts gerendert
     bzw. ein vorhandener Span wieder entfernt. Erwartet, dass buildSteps die
     Klasse toz-step--check bereits gesetzt hat. Styling: toz-lpo-gallery.css */
  function ensureBackPrice(container, opt) {
    var label = container.querySelector(':scope > .toz-step--check .cl-po--checkbox-item');
    if (!label) return;
    var price = label.querySelector(':scope > .toz-perso-back-price');
    var prices = findPrices(opt, 'back');
    if (!prices) {
      if (price) price.remove();
      return;
    }
    if (!price) {
      price = document.createElement('span');
      price.className = 'toz-perso-back-price';
      price.setAttribute('aria-hidden', 'true');
      price.innerHTML =
        '<s class="toz-perso-back-price__old"></s>' +
        '<span class="toz-perso-back-price__new"></span>';
      label.appendChild(price);
    }
    var oldEl = price.querySelector('.toz-perso-back-price__old');
    var newEl = price.querySelector('.toz-perso-back-price__new');
    if (!oldEl || !newEl) return;
    setPriceTexts(oldEl, newEl, prices.oldText, prices.newText);
  }

  /* Mehrere Optionen (z. B. Bild + Text + Rückseite): alles in EINER grossen
     Personalisieren-Box als nummerierte Schritte. Ein einzelnes Textfeld
     (Standardfall) bleibt unverändert. */
  var STEP_TITLES = {
    'bild': 'Bild hochladen',
    'text': 'Text eingeben',
    'bild 2': 'Bild für die Rückseite',
    'text 2': 'Text für die Rückseite'
  };

  function stepTitle(opt) {
    var name = (opt.getAttribute('data-option') || '').trim();
    var key = name.toLowerCase();
    if (STEP_TITLES[key]) return STEP_TITLES[key];
    var back = /\s\d+$/.test(name) ? ' für die Rückseite' : '';
    if (opt.querySelector('.cl-po--upload')) return 'Bild' + (back || ' hochladen');
    if (opt.querySelector('textarea, input[type="text"]')) return 'Text' + (back || ' eingeben');
    return name;
  }

  function ensureChild(parent, cls, tag, before) {
    var el = parent.querySelector(':scope > .' + cls);
    if (!el) {
      el = document.createElement(tag || 'span');
      el.className = cls;
      el.setAttribute('aria-hidden', 'true');
      parent.insertBefore(el, before === undefined ? parent.firstChild : before);
    }
    return el;
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function buildSteps(container) {
    var opts = container.querySelectorAll(':scope > .cl-po--option');
    var n = 0;
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var name = opt.getAttribute('data-option') || '';
      var isCheck = !!opt.querySelector('.cl-po--checkbox-item') &&
                    !opt.querySelector('textarea, .cl-po--upload');
      var isSub = /\s\d+$/.test(name);
      if (!opt.classList.contains('toz-step')) opt.classList.add('toz-step');
      opt.classList.toggle('toz-step--sub', isSub);
      opt.classList.toggle('toz-step--check', isCheck);
      var num = opt.querySelector(':scope > .toz-step-num');
      if (isSub) {
        if (num) num.remove();
      } else {
        n++;
        setText(ensureChild(opt, 'toz-step-num'), String(n));
      }
      var title = opt.querySelector(':scope > .toz-step-title');
      if (isCheck) {
        if (title) title.remove();
      } else {
        title = ensureChild(opt, 'toz-step-title', 'span',
          opt.querySelector(':scope > .toz-step-num') ? opt.querySelector(':scope > .toz-step-num').nextSibling : opt.firstChild);
        setText(title, stepTitle(opt));
      }
      var wrap = opt.querySelector('.cl-po--upload');
      if (wrap) watchUpload(wrap);
    }
  }

  /* Upload-Feld: Ladezustand direkt im Feld (Spinner + Prozent) statt der
     App-Ladeleiste; danach Vorschaubild + Dateiname + Entfernen. */
  function syncUpload(wrap) {
    var prog = wrap.querySelector('.cl-po--preview-progress');
    var label = wrap.querySelector('.cl-po--upload-button');
    var span = label && label.querySelector(':scope > span');
    var files = wrap.querySelector('.cl-po--upload-files');
    var row = files && files.querySelector(':scope > div');
    var hidden = wrap.querySelector('input[type="hidden"][name^="properties"]');
    var loading = !!(prog && prog.style.display && prog.style.display !== 'none');
    var hasFile = !loading && !!(row && row.textContent.replace('×', '').trim());
    var pct = 0;
    if (loading && prog.max) pct = Math.max(0, Math.min(100, Math.round(prog.value / prog.max * 100)));
    wrap.classList.toggle('toz-uploading', loading);
    wrap.classList.toggle('toz-has-file', hasFile);
    if (label) {
      var busy = loading ? 'true' : 'false';
      if (label.getAttribute('aria-busy') !== busy) label.setAttribute('aria-busy', busy);
      var p = (loading ? pct : 0) + '%';
      if (label.style.getPropertyValue('--toz-progress') !== p) label.style.setProperty('--toz-progress', p);
    }
    if (span) {
      var text = loading
        ? 'Wird hochgeladen …' + (pct > 0 && pct < 100 ? ' ' + pct + ' %' : '')
        : 'Datei auswählen';
      if (span.getAttribute('data-toz-text') !== text) span.setAttribute('data-toz-text', text);
    }
    if (files) {
      var url = hasFile && hidden && /^https:\/\//.test(hidden.value) ? hidden.value : '';
      var thumb = url ? 'url("' + url.replace(/"/g, '%22') + '")' : 'none';
      if (files.style.getPropertyValue('--toz-thumb') !== thumb) files.style.setProperty('--toz-thumb', thumb);
    }
    syncPreview();
  }

  function watchUpload(wrap) {
    syncUpload(wrap);
    if (wrap.__tozUploadWatch) return;
    wrap.__tozUploadWatch = true;
    new MutationObserver(function () { syncUpload(wrap); })
      .observe(wrap, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'value'] });
  }

  function ensureHeads() {
    var options = document.querySelectorAll('.cl-po--option[data-option="Text"]');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var container = opt.parentElement;
      var multi = !!container && container.classList.contains('cl-po--options') &&
                  container.querySelectorAll(':scope > .cl-po--option').length > 1;
      var ownHead = opt.querySelector(':scope > .toz-perso-head');
      if (multi) {
        if (!container.classList.contains('toz-perso-multi')) container.classList.add('toz-perso-multi');
        if (ownHead) ownHead.remove();
        if (!container.querySelector(':scope > .toz-perso-head')) {
          container.insertBefore(makeHead(), container.firstChild);
        }
        /* Bild + Text: Kopfzeile = Vorderseite (sonst Summe) aus Liquid, Fallback höherer
           Streichpreis; Rückseiten-Preis an der Checkbox */
        syncHeadPrices(container.querySelector(':scope > .toz-perso-head'), opt, true);
        buildSteps(container);
        ensureBackPrice(container, opt);
      } else {
        if (container && container.classList.contains('toz-perso-multi')) {
          container.classList.remove('toz-perso-multi');
          var oldHead = container.querySelector(':scope > .toz-perso-head');
          if (oldHead) oldHead.remove();
        }
        if (!ownHead) opt.insertBefore(makeHead(), opt.firstChild);
        syncHeadPrices(opt.querySelector(':scope > .toz-perso-head'), opt, false);
      }
      if (!opt.querySelector(':scope > .toz-perso-preview-btn[data-slide="0"]')) {
        var old = opt.querySelector(':scope > .toz-perso-preview-btn:not([data-slide])');
        if (old) old.remove();
        makePreviewBtn(opt, 0);
      }
      syncValidation(opt);
    }
    syncPreview();
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('.cl-po--options')) syncPreview();
  });

  ensureHeads();
  new MutationObserver(ensureHeads).observe(document.documentElement, { childList: true, subtree: true });
})();

/* TOZ24: "In den Warenkorb" mit Personalisierung. Die App rendert beim Klick
   das Motiv und lädt es hoch (eigene Ladebalken oben im Feld, ausgeblendet in
   toz-lpo-gallery.css). Stattdessen wird der Button selbst zum Ladebalken:
   1. "Motiv wird hochgeladen … 42 %" (Füllung = Fortschritt)
   2. "Wird in den Warenkorb gelegt …" (Theme-Ajax läuft, Füllung voll)
   Ohne Personalisierung bleibt der normale Theme-Spinner. */
(function () {
  var timer = null;
  var phase = '';
  var seenUpload = false;
  var idleTicks = 0;

  function buttons() {
    return document.querySelectorAll('.single-add-to-cart-button');
  }

  function uploadProgress() {
    var bars = document.querySelectorAll('.cl-po--wrapper > progress.cl-po--preview-progress');
    if (!bars.length) return -1;
    var sum = 0;
    for (var i = 0; i < bars.length; i++) {
      var max = bars[i].max || 100;
      sum += Math.max(0, Math.min(1, (bars[i].value || 0) / max));
    }
    return Math.round(sum / bars.length * 100);
  }

  function ensureStatus(btn) {
    var st = btn.querySelector(':scope > .toz-atc-status');
    if (!st) {
      st = document.createElement('span');
      st.className = 'toz-atc-status';
      st.setAttribute('aria-live', 'polite');
      st.innerHTML = '<span class="toz-atc-spinner" aria-hidden="true"></span><span class="toz-atc-label"></span>';
      btn.appendChild(st);
    }
    return st;
  }

  function render(text, pct) {
    var list = buttons();
    for (var i = 0; i < list.length; i++) {
      var btn = list[i];
      if (!text) {
        btn.classList.remove('toz-atc-busy');
        btn.removeAttribute('aria-busy');
        continue;
      }
      var label = ensureStatus(btn).querySelector('.toz-atc-label');
      if (label.textContent !== text) label.textContent = text;
      btn.style.setProperty('--toz-atc-progress', pct + '%');
      btn.classList.add('toz-atc-busy');
      btn.setAttribute('aria-busy', 'true');
    }
  }

  function anyLoading() {
    var list = buttons();
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('loading')) return true;
    }
    return false;
  }

  function tick() {
    var pct = uploadProgress();
    if (pct >= 0) {
      seenUpload = true;
      idleTicks = 0;
      phase = 'upload';
      render('Motiv wird hochgeladen …' + (pct > 0 && pct < 100 ? ' ' + pct + ' %' : ''), Math.max(6, pct));
      return;
    }
    if (seenUpload && anyLoading()) {
      idleTicks = 0;
      phase = 'cart';
      render('Wird in den Warenkorb gelegt …', 100);
      return;
    }
    /* kurz warten, ob der Theme-Ajax noch startet, dann zurücksetzen */
    if (seenUpload && phase === 'upload' && idleTicks < 15) {
      idleTicks++;
      render('Wird in den Warenkorb gelegt …', 100);
      return;
    }
    stop();
  }

  function start() {
    if (timer) return;
    tick();
    timer = setInterval(tick, 100);
  }

  function stop() {
    clearInterval(timer);
    timer = null;
    phase = '';
    seenUpload = false;
    idleTicks = 0;
    render('', 0);
  }

  new MutationObserver(function (records) {
    if (timer) return;
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && n.matches('progress.cl-po--preview-progress') &&
            n.parentElement && n.parentElement.classList.contains('cl-po--wrapper')) {
          start();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
